import { useLocalStorage } from 'utils/hooks/useLocalStorage';

export enum TEMPLATE_INDEX_VIEWS {
  CARD = 'template-index-view-table',
  TABLE = 'template-index-view-card',
}

export const useViewControl = () => {
  const [activeView, setActiveView] = useLocalStorage(
    'template-index-view',
    TEMPLATE_INDEX_VIEWS.TABLE,
  );

  return {
    activeView,
    isCardView: activeView === TEMPLATE_INDEX_VIEWS.CARD,
    isTableView: activeView === TEMPLATE_INDEX_VIEWS.TABLE,
    setActiveView,
    TEMPLATE_INDEX_VIEWS,
  };
};
